import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1c3d2e0e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "research-group-list" }
const _hoisted_2 = { class: "help-text" }
const _hoisted_3 = {
  key: 0,
  class: "alert alert-primary alert-sm"
}
const _hoisted_4 = {
  key: 1,
  class: "list-unstyled group-list"
}
const _hoisted_5 = {
  key: 2,
  class: "actions-row"
}

import { computed } from 'vue'
import { useDataGroupStore } from '@/gp/DataGroupStore'
import { DataGroup, DataGroupType, GroupMemberRole, ItemPermissions } from '@/gp/GroupAdminModel'
import { LoadMode } from '@/util/AsyncData'
import ResearchGroupCard from './ResearchGroupCard.vue'
import { useTokenManager } from '@/auth/TokenManager'
import { useDataGroupMemberStore } from '@/gp/DataGroupMemberStore'
import { useUserStore } from '@/gp/UserStore'
import { useFamilyGroupMemberStore } from '@/gp/FamilyGroupMemberStore'
import { sortBy, uniq } from 'lodash'


export default /*#__PURE__*/_defineComponent({
  __name: 'ResearchGroupList',
  props: {
    userId: {},
    forUserProfile: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;



const userStore = useUserStore()
const dataGroupStore = useDataGroupStore()
const dataGroupMemberStore = useDataGroupMemberStore()
const familyGroupMemberStore = useFamilyGroupMemberStore()
const tokenManager = useTokenManager()

const userIdRef = computed(() => props.userId || tokenManager.current.userId)
const isSelfRef = computed(() => userIdRef.value == tokenManager.current.userId)
const userRef = computed(() => userStore.getAsyncUser(userIdRef.value, LoadMode.EnsureLoaded)?.data)
const userPermissions = computed(() => 
  userStore.getAsyncPermissions(userIdRef.value, LoadMode.EnsureLoaded)?.data ?? ItemPermissions.None)

const visibleResearchGroupsRef = computed(() => 
  dataGroupStore.getVisibleGroups(LoadMode.EnsureLoaded).filter(dg => dg.groupType == DataGroupType.Research))

const ownedDataGroupIdsRef = computed(() => 
  dataGroupMemberStore.getMembersForUsers([userIdRef.value], LoadMode.EnsureLoaded)
    .filter(dm => dm.role == GroupMemberRole.Owner)
    .map(dm => dm.dataGroupId!)) 

const ownedResearchGroupsRef = computed(() =>
  dataGroupStore.getLoadedGroupList(ownedDataGroupIdsRef.value)
    .filter(dg => dg.groupType == DataGroupType.Research))

const familyGroupIdsRef = computed(() => 
  familyGroupMemberStore.getMembersForUsers([props.userId], LoadMode.EnsureLoaded)
  .map(fm => fm.familyGroupId!))

const sharedDataGroupIdsRef = computed(() => {
  const dms = dataGroupMemberStore.getMembersForFamilyGroups(familyGroupIdsRef.value, LoadMode.EnsureLoaded)
  return uniq(dms.map(dm => dm.dataGroupId!))
})
const sharedResearchGroupsRef = computed(() => {
  const researchGroups = dataGroupStore.getLoadedGroupList(sharedDataGroupIdsRef.value)
    .filter(dg => dg.groupType == DataGroupType.Research)
    .filter(dg => !ownedDataGroupIdsRef.value.includes(dg.id!))
  return sortBy(researchGroups, dg => dg.name)
})

const hasGroupsRef = computed(() => ownedResearchGroupsRef.value.length || sharedResearchGroupsRef.value.length)

const researchGroupLimitRef = computed(() => userRef.value?.limitsDisabled ? undefined : userRef.value?.limits?.researchGroupLimit)
const isOwnedGroupsUnderLimitRef = computed(() => isSelfRef.value && ownedResearchGroupsRef.value.length < (researchGroupLimitRef.value ?? Infinity))
const canUpgradeRef = computed(() => isSelfRef.value && !tokenManager.current.isSupervised)
const canAddRef = computed(() => !props.forUserProfile && isSelfRef.value && !tokenManager.current.isSupervised && isOwnedGroupsUnderLimitRef.value)


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, [
      (hasGroupsRef.value)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (isSelfRef.value)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode("Upload a file from your genealogy program to share a family tree with others.")
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode("These are the trees this user manages that are also visible to you.")
                ], 64))
          ], 64))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            (isSelfRef.value)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode("You do not manage any trees, and no trees have been shared with you.")
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode("This user does not manage any trees that are visible to you.")
                ], 64))
          ], 64))
    ]),
    (!isOwnedGroupsUnderLimitRef.value && canUpgradeRef.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createTextVNode(" You have reached the limit on your plan and cannot add any more trees. "),
          _createVNode(_component_router_link, { to: "/plans" }, {
            default: _withCtx(() => [
              _createTextVNode(" Upgrade my plan ")
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    (hasGroupsRef.value)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ownedResearchGroupsRef.value, (rg) => {
            return (_openBlock(), _createElementBlock("li", {
              key: rg.id
            }, [
              _createVNode(ResearchGroupCard, {
                "data-group-id": rg.id!
              }, null, 8, ["data-group-id"])
            ]))
          }), 128)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sharedResearchGroupsRef.value, (rg) => {
            return (_openBlock(), _createElementBlock("li", {
              key: rg.id
            }, [
              _createVNode(ResearchGroupCard, {
                "data-group-id": rg.id!
              }, null, 8, ["data-group-id"])
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (canAddRef.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          (!hasGroupsRef.value)
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 0,
                class: "btn btn-primary",
                to: "/syncapp"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Upload my tree ")
                ]),
                _: 1
              }))
            : (_openBlock(), _createBlock(_component_router_link, {
                key: 1,
                to: "/learn/sync"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Upload another tree ")
                ]),
                _: 1
              }))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})